import React, { Component } from 'react'
import SectionRoster from '../SectionRoster'
import './roster.css'

class Roster extends Component {

  render() {
    let sectionRosters = this.props.data.map(
      (datum, index) =>
        <div style={{paddingBottom: '60px'}} key={index}>
          <SectionRoster
            data={datum}
            nCellsPerRow={this.props.nCellsPerRow}
            nCellsPerRowMobile={this.props.nCellsPerRowMobile}
            height={350}
            images={this.props.images}>
          </SectionRoster>

        </div>
      );

    return (
      <div>
        {sectionRosters}
      </div>
    );
  }
}

export default Roster
